import Box from "@mui/material/Box";
import { Grid, Typography, Paper, Divider } from "@mui/material";
import React from "react";
import { isMobile } from "react-device-detect";

const ServiceWithDetailsForm = ({ generalServices }) => {
  const title = generalServices?.additionalData || "-";
  const details = generalServices?.notes || "-";

  return (
    <>
      <Box
        sx={{
          background: "#fff",
          fontWeight: "bold",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 1.5,
          px: 3,
          width: isMobile ? "100%" : 300,
          borderRadius: "8px",
          border: "2px solid",
          borderColor: "primary.main",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.main" }}>
          تفاصيل الطلب
        </Typography>
      </Box>
      <Paper
        elevation={1}
        sx={{
          p: 3,
          borderRadius: "12px",
          border: "1px solid #e0e0e0",
        }}
      >
        <Grid container spacing={3}>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>التفاصيل:</Typography>
            <Typography
              component="div"
              sx={{
                p: 2,
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                backgroundColor: "#f5f5f5",
                minHeight: "56px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {details}
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography sx={{ fontWeight: "bold", mb: 1 }}>العنوان:</Typography>
            <Typography
              component="div"
              sx={{
                p: 2,
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                backgroundColor: "#f5f5f5",
                minHeight: "56px",
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
              }}
            >
              {title}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
      <Divider />
    </>
  );
};

export default ServiceWithDetailsForm;
